import { Component, OnInit } from '@angular/core';
import { TcPage } from '@tc/core';
import { Store } from '@ngrx/store';
import { getBreadcrumb } from '../../modules/main/store/breadcrumb/breadcrumb.actions';
import { RouteEnum } from '../../modules/main/enums/routes.enum';

@Component({
  selector: 'app-expert-analysis-page',
  templateUrl: './expert-analysis-page.component.html',
  styleUrls: ['./expert-analysis-page.component.scss']
})
export class ExpertAnalysisPageComponent extends TcPage implements OnInit {

  constructor(store: Store<any>) {
    super(store);
  }

  ngOnInit(): void {
    this.store.dispatch(getBreadcrumb({route: RouteEnum.ExpertAnalysis}))
  }

}
